export const default_country_code = { code: 'GB', label: 'United Kingdom', phone: '44' };

export const countries = [
    { code: 'GB', label: 'United Kingdom', phone: '44' }
  ];